import { EQUIPMENT_MESSAGE } from '@gymaholic/packages'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import Collapsible from 'components/Collapsible/index.js'
import { View } from 'components/View.js'

const messages = defineMessages({
  whatEquipment: {
    id: 'ExerciseContentEquipment.whatEquipment',
    defaultMessage: 'What equipment is needed to perform {exerciseNamePlural}?'
  },
  whatEquipmentBodyweightAnswer: {
    id: 'ExerciseContentEquipment.whatEquipmentBodyweightAnswer',
    defaultMessage: 'The {exerciseName} is a bodyweight exercise, so it does not require any equipment. You can do it anywhere, at the gym or at home.'
  },
  whatEquipmentOthersAnswer: {
    id: 'ExerciseContentEquipment.whatEquipmentOthersAnswer',
    defaultMessage: 'The equipment needed to do the {exerciseNamePlural}:'
  }
})

/**
 * @param {ExerciseContentProps} props
 * @return {Element}
 * @constructor
 */
export default function ExerciseContentEquipment ({
  exerciseNamePlural,
  equipment,
  exerciseName

}) {
  const intl = useIntl()

  const whatEquipment = (
    formatMessageIntlUtil(
      intl,
      messages.whatEquipment,
      { exerciseNamePlural }
    )
  )

  const isBodyWeight = equipment.find((equipmentId) => equipmentId === 105)
  let text
  let equipmentList
  if (isBodyWeight) {
    text = (
      formatMessageIntlUtil(intl, messages.whatEquipmentBodyweightAnswer, { exerciseName })
    )
  } else {
    text = (
      formatMessageIntlUtil(
        intl,
        messages.whatEquipmentOthersAnswer,
        {
          exerciseNamePlural,
          equipmentCount: equipment.length
        }
      )
    )

    equipmentList = (
      <ul
        style={{
          paddingLeft: '1.5rem',
          margin: 0,
          marginTop: '10px'
        }}
      >
        {
          equipment.map((equipmentId, index) => (
            <li key={index}>{formatMessageIntlUtil(
              intl,
              EQUIPMENT_MESSAGE[equipmentId]
            )}
            </li>
          ))
        }
      </ul>
    )
  }

  return (
    <View mt={2}>
      <Collapsible label={whatEquipment}>
        {text}
        {equipmentList}
      </Collapsible>
    </View>
  )
}
